import { gatewayClient } from './api-grpc';
import { User } from '../gen/proto/api/gateway/v1/gateway_pb';

export const userApi = {
  async getByEmail(email: string): Promise<User | null> {
    try {
      const response = await gatewayClient.getUserByEmail({
        email: email,
      });
      if (!response.user) {
        return null;
      }
      return response.user;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
};
